import { useCallback, useEffect, useRef, useState } from 'react'
import { geographicFilterTiming } from './filterAnimation'

/**
 * Holds the map back until its tiles are in, so they don't show up one by one: it is revealed once the
 * min wait has passed and the tiles have loaded, or at the max wait at the latest.
 * `handleTilesLoad` is the tile layer's load handler.
 */
export const useMapReveal = () => {
  const [isRevealed, setIsRevealed] = useState(false)
  const tilesLoaded = useRef(false)
  const minWaitPassed = useRef(false)

  useEffect(() => {
    const { mapMinWait, mapMaxWait } = geographicFilterTiming.open
    const minTimer = setTimeout(() => {
      minWaitPassed.current = true
      if (tilesLoaded.current) setIsRevealed(true)
    }, mapMinWait * 1000)
    const maxTimer = setTimeout(() => setIsRevealed(true), mapMaxWait * 1000)

    return () => {
      clearTimeout(minTimer)
      clearTimeout(maxTimer)
    }
  }, [])

  const handleTilesLoad = useCallback(() => {
    tilesLoaded.current = true
    if (minWaitPassed.current) setIsRevealed(true)
  }, [])

  return { isRevealed, handleTilesLoad }
}
